/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_5_TitleInputs */

const et_portfolio_project_5_title = /** @type {(inputs: Portfolio_Project_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla 1 sekundi laadimiskiirus – paremad positsioonid ja kasutajate hoidmine.`)
};

const en_portfolio_project_5_title = /** @type {(inputs: Portfolio_Project_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sub-1 second load speed - improved rankings and user retention.`)
};

/**
* | output |
* | --- |
* | "Sub-1 second load speed - improved rankings and user retention." |
*
* @param {Portfolio_Project_5_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_5_title = /** @type {((inputs?: Portfolio_Project_5_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_5_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_5_title(inputs)
	return en_portfolio_project_5_title(inputs)
});